<ng-container *transloco="let t; read: 'partials.exercise_settings'">

  <div [cdkDropListGroup]>

    <p class="heading" style="margin-top: 0">{{ t('not_assigned') }}</p>
    <div
      cdkDropList
      [cdkDropListData]="stock.users"
      (cdkDropListDropped)="drop($event)"
      (cdkDropListEntered)="hoverStock = true"
      (cdkDropListExited)="hoverStock = false"
      class="drop-box stock"
      [class.hover]="hoverStock"
    >
      <ng-container *ngFor="let user of stock.users">
        <span
          [cdkDragData]="user"
          cdkDrag
        >
          <app-avatar
            [user]="user"
            [type]="user.role"
            [mode]="'small'"
            [pointer]="true"
            cdkDragHandle
          ></app-avatar>
          <span
            class="placeholder"
            *cdkDragPlaceholder
          >&nbsp;</span>
        </span>
      </ng-container>
      <p class="drag-hint" *ngIf="stock.users?.length === 0">{{ t('stock_hint') }}</p>
    </div>

    <p class="heading">{{ t('groups') }}</p>
    <div class="p-grid">

      <div *ngFor="let group of groups; let i = index" class="p-col-4">

        <div class="group-container">

          <div class="group-header">
            {{ group.name }}
            <div class="group-controls">
              <i *ngIf="notEnoughUsers(group) as message" class="pi pi-exclamation-triangle p-mr-4" style="color: red" [pTooltip]="message"></i>
              <button pButton type="button" *ngIf="group.inEdit !== true" (click)="group.inEdit = true" [icon]="'pi pi-pencil'" class="p-button-sm p-button-link"></button>
              <button pButton type="button" *ngIf="group.inEdit === true" (click)="group.inEdit = false" [icon]="'pi pi-check'" class="p-button-sm p-button-link"></button>
              <button pButton type="button" *ngIf="canDeleteGroup()" (click)="deleteGroup(group)" [icon]="'pi pi-trash'" class="p-button-sm danger-button p-button-link"></button>
            </div>
          </div>

          <div *ngIf="group.inEdit === true" class="p-grid">
            <div class="p-col-6">
              <p class="heading">{{ t('name') }}</p>
              <input type="text" pInputText [(ngModel)]="group.name" [ngModelOptions]="{standalone: true}" class="p-inputtext-sm">
            </div>
            <div class="p-col-6">
              <p class="heading">{{ t('moderator') }}</p>
              <p-dropdown
                [options]="group.moderatorOptions"
                [ngModel]="group.moderator"
                (onChange)="saveModerator(group, $event)"
                [ngModelOptions]="{standalone: true}"
              ></p-dropdown>
            </div>
          </div>

          <p class="heading">{{ t('observers') }}</p>
          <div
            class="drop-box"
            cdkDropList
            [cdkDropListData]="group.observers"
            [cdkDropListEnterPredicate]="checkForObserver"
            (cdkDropListDropped)="drop($event)"
            (cdkDropListEntered)="group.hoverObservers = true"
            (cdkDropListExited)="group.hoverObservers = false"
            [class.hover]="group.hoverObservers"
          >
            <ng-container *ngFor="let observer of group.observers">
              <span
                [cdkDragData]="observer"
                cdkDrag
              >
                <app-avatar
                  [user]="observer"
                  [type]="observer.role"
                  [mode]="'small'"
                  [pointer]="true"
                  cdkDragHandle
                ></app-avatar>
                <span
                  class="placeholder"
                  *cdkDragPlaceholder
                >&nbsp;</span>
              </span>
            </ng-container>
            <p class="drag-hint" *ngIf="group.observers?.length === 0">{{ t('observer_hint') }}</p>
          </div>

          <p class="heading">{{ t('candidates') }}</p>
          <div
            class="drop-box flex"
            cdkDropList
            [cdkDropListData]="group.candidates"
            [cdkDropListEnterPredicate]="checkForCandidate"
            (cdkDropListDropped)="dropToCandidates($event)"
            (cdkDropListEntered)="group.hoverCandidates = true"
            (cdkDropListExited)="group.hoverCandidates = false"
            [class.hover]="group.hoverCandidates"
            [class.team]="exercise.isTeam() === true"
          >
            <div
              *ngIf="group.candidates?.length > 0"
              class="p-d-flex"
            >
              <ng-container *ngFor="let candidate of group.candidates">
                <div
                  class="candidate-container"
                  [cdkDragData]="candidate"
                  cdkDrag
                >
                  <app-avatar
                    [user]="candidate"
                    [type]="candidate.role"
                    [mode]="'small'"
                    [pointer]="true"
                    cdkDragHandle
                  ></app-avatar>
                  <app-avatar
                    [user]="candidate"
                    [type]="candidate.role"
                    [mode]="'small'"
                    *cdkDragPreview
                  ></app-avatar>
                  <span
                    class="placeholder"
                    *cdkDragPlaceholder
                  >&nbsp;</span>
                  <ng-container *ngIf="matrix === true">
                    <div *ngFor="let observer of candidate.observers" (click)="assignObserver(candidate, observer)" class="linked-observer">
                      <app-avatar
                        [user]="observer"
                        [type]="'observer'"
                        [mode]="'small'"
                        [pointer]="true"
                        [inactive]="observer.assigned === false"
                      ></app-avatar>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
            <p class="drag-hint" *ngIf="group.candidates?.length === 0">{{ t('candidate_hint') }}</p>
          </div>

        </div>
      </div>

    </div>

    <button *ngIf="canAddGroup()" pButton type="button" (click)="addGroup()" [icon]="'pi pi-plus'" [label]="t('new_group')" class="p-button-sm p-button-secondary"></button>
    <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" label="{{ t('allocation') }}" class="p-button-sm p-button-secondary p-ml-2"></button>
    <p-menu #menu [popup]="true" [model]="items" [appendTo]="'body'"></p-menu>

  </div>

</ng-container>
